<div class="fondo">
    <iframe src="./web2/login.php" height="600" width=100%  name="miandecorp" title="Mi-- Andecorp" ></iframe>
</div>

 
